/**
 * Firebase Analytics bridge — calls window.logEvent only when running
 * on a native platform (Capacitor/Android) where the function is injected.
 */
export function logEvent(eventName: string): void {
  if (typeof window !== 'undefined' && typeof (window as any).logEvent === 'function') {
    (window as any).logEvent(eventName);
  }
}
